import { timezoneUtils } from "@/lib/timezone";

export function formatHolidayDateRange(startDateTime: string, endDateTime: string): string {
  const startDate = timezoneUtils.fromISO(startDateTime);
  const endDate = timezoneUtils.fromISO(endDateTime);

  return startDate.hasSame(endDate, "day")
    ? `${startDate.toFormat("MMM dd, yyyy")} • ${startDate.toFormat("h:mm a")} - ${endDate.toFormat("h:mm a")}`
    : `${startDate.toFormat("MMM dd, yyyy h:mm a")} - ${endDate.toFormat("MMM dd, yyyy h:mm a")}`;
}
